// Store
import store from "@/store";

export interface AppAdministratorResourcesDietsListFormCreate {
  organization_id: string;
  content: {
    name: string;
    type: string;
    description: string;
  };
}

export class AppAdministratorResourcesDietsListFormCreate implements AppAdministratorResourcesDietsListFormCreate {
  organization_id: string;
  content: {
    name: string;
    type: string;
    description: string;
  };

  constructor() {
    this.organization_id = store.getters.getOrganizationMember.organization_id ?? "";
    this.content = {
      name: "",
      type: "",
      description: "",
    };
  }
}